import { createStore } from 'vuex'

import PnpToolStore from './modules/pnp/PnpToolStore'

export default createStore({
  // state: {},
  mutations: {},
  actions: {},
  modules: {
    PnpToolStore,
  },
})
